module.exports = __webpack_public_path__ + "img/academy.9a7afb7e.svg";